import styled from 'styled-components'

export const StyledLoginButton = styled.button`
  width: 96px;
  height: 40px;
  background: transparent;
  border-radius: 4px;
  color: #0AA1F4;
  border: 1px solid #0AA1F4;
  margin-left: 24px;
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 28px;
  line-height: 40px;
  margin-bottom: 48px;
  text-align: center;
  margin-top: 32px;
`

export const StyledImage = styled.img`
  margin: 24px 0px 0px 0px;
`

export const StyledCheckBox = styled.div`
  margin-top: 45px;
`

export const RegistrationFooter = styled.div`
  height: 104px;
`
